const visMenu = {
  key: 'vis',
  caption: 'VIS',
  subMenuItems: [
    {
      key: 'vis-vin',
      caption: 'Get VIN',
      onClick: () => console.log('Get VIN'),
    },
  ],
};

export default visMenu;
